function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M37.73 33.08V28.7a8 8 0 10-8.33-13.63A12 12 0 109.73 26.7v4.92A16 16 0 1131.7 10a12.25 12.25 0 012-.2 12 12 0 014 23.3zm-22 .7c-1.1 0-1-.9-1-2v-8c0-1.1-.1-2 1-2s1 .9 1 2v8c0 1.1.11 2-1 2zm0 4a2 2 0 11-2 2 2 2 0 012-2zm8 0c-1.1 0-1-.9-1-2v-8c0-1.11-.1-2 1-2s1 .89 1 2v8c0 1.1.1 2-1 2zm0 4a2 2 0 11-2 2 2 2 0 012-2zm8-8c-1.1 0-1-.9-1-2v-8c0-1.1-.1-2 1-2s1 .9 1 2v8c0 1.1.1 2-1 2zm0 4a2 2 0 11-2 2 2 2 0 012-2z"
});

var SvgHail = function SvgHail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 47.16 49.18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hail.e1ddd5d4.svg";
export { ForwardRef as ReactComponent };